import { useCallback } from 'react';

import { useConfirmPopup } from 'src/components/ConfirmPopup';

export const useOpenConfirmPopup = ({ mode, title, content, submitButtonText, withReject }) => {
  const confirmPopup = useConfirmPopup();

  return useCallback(() => {
    return confirmPopup({
      mode,
      title,
      content,
      buttons: {
        confirm: submitButtonText,
      },
      withReject,
    })
      .then(() => true)
      .catch(() => false);
  }, [confirmPopup, mode, title, content, submitButtonText, withReject]);
};
